module.exports = __webpack_public_path__ + "static/media/covi_can_sea.80bafe8a.png";